export default __webpack_public_path__ + "static/media/bubble4.0cd5a7ce.png";